import {
  SMSCollectionService,
  SMSCollectionError
} from '@/services/sms-collection.service';
import ApiService from '@/services/api.service';

const state = {
  loading: false,
  templateGroups: [],
  currentPage: 1,
  total: 0,
  pages: 0,
  serverResponse: null
};

const getters = {
  loading: state => {
    return state.loading;
  },

  templateGroups: state => {
    return state.templateGroups;
  },

  currentPage: state => {
    return state.currentPage;
  },

  total: state => {
    return state.total;
  },

  pages: state => {
    return state.pages;
  },

  serverResponse: state => {
    return state.serverResponse;
  }
};

const actions = {
  async fetchSMSCollections({ commit }, { page }) {
    commit('startRequest');

    try {
      const response = await SMSCollectionService.fetchAll(page);
      if (response.hasOwnProperty('groups')) {
        commit('collectionFetchAllSuccess', response);

        return true;
      } else {
        commit('collectionFetchAllError', response);

        return false;
      }
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('collectionFetchAllError', {
          status: e.errorCode,
          message: e.message
        });
      }

      return false;
    }
  },

  async fetchGroupTemplates({ commit }, { groupId, page }) {
    commit('startRequest');

    try {
      const response = await SMSCollectionService.fetchGroupTemplates(
        groupId,
        page
      );
      response.groupId = groupId;
      commit('groupTemplatesFetchAllSuccess', response);
      commit('incrementTemplateNextPage', groupId);

      return true;
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('collectionFetchAllError', {
          status: e.errorCode,
          message: e.message
        });
      }

      return false;
    }
  },

  async createGroup({ commit }, { data }) {
    commit('startRequest');
    try {
      const response = await SMSCollectionService.createGroup(data);
      commit('requestComplete', response);
      if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
        let group = await SMSCollectionService.fetchGroup(response.id);
        if (group.hasOwnProperty('id') && group.id > 0) {
          commit('groupCreateSuccess', group);
        }
        return true;
      } else {
        commit('requestError', response);
        return false;
      }
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('requestError', {
          errorCode: e.errorCode,
          errorMessage: e.message
        });
      }
      return false;
    }
  },

  async deleteGroup({ commit }, { id }) {
    commit('startRequest');
    try {
      const response = await SMSCollectionService.deleteGroup(id);
      if (response.status === 'success') {
        commit('deleteGroupSuccess', [id]);

        return true;
      } else {
        commit('requestError', response);

        return false;
      }
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('requestError', { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async saveMessage({ commit }, { data, groupId }) {
    commit('startRequest');
    try {
      const response = await SMSCollectionService.saveMessage(groupId, data);
      if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
        let template = await SMSCollectionService.fetchMessage(
          groupId,
          response.id
        );
        if (template.id > 0) {
          commit('saveTemplateSuccess', template);
        }
        return true;
      } else {
        commit('requestError', response);
        return false;
      }
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('requestError', { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async updateMessage({ commit }, { data, groupId, id }) {
    commit('startRequest');
    try {
      const response = await SMSCollectionService.updateMessage(
        groupId,
        id,
        data
      );
      if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
        data.groupId = groupId;
        data.id = id;
        commit('updateMessageSuccess', data);
        return true;
      } else {
        commit('requestError', response);
        return false;
      }
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('requestError', { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async deleteMessage({ commit }, { groupId, id }) {
    commit('startRequest');
    try {
      const response = await SMSCollectionService.deleteMessage(groupId, id);
      if (response.status === 'success') {
        commit('deleteMessageSuccess', { id: groupId, messageIds: [id] });

        return true;
      } else {
        commit('requestError', response);

        return false;
      }
    } catch (e) {
      if (e instanceof SMSCollectionError) {
        commit('requestError', { status: e.errorCode, message: e.message });
      }

      return false;
    }
  }
};

const mutations = {
  startRequest(state) {
    state.loading = true;
    state.serverResponse = null;
  },
  requestComplete(state, response) {
    state.loading = false;
    state.serverResponse = response;
  },

  requestError(state, response) {
    state.loading = false;
    state.serverResponse = response;
  },

  collectionFetchAllSuccess(state, response) {
    for (let i = 0; i < response.groups.length; i++) {
      let flag = false;
      for (let j = 0; j < state.templateGroups.length; j++) {
        if (state.templateGroups[j].id === response.groups[i].id) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        response.groups[i].templates = [];
        response.groups[i].template_pages = 0;
        response.groups[i].templates_total = 0;
        response.groups[i].templates_next_page = 1;

        state.templateGroups.push(response.groups[i]);
      }
    }
    state.total = response.total;
    state.pages = response.pages;
    state.loading = false;
  },

  collectionFetchAllError(state, response) {
    state.loading = false;
    state.serverResponse = response;
  },

  incrementTemplateNextPage(state, groupId) {
    for (let h = 0; h < state.templateGroups.length; h++) {
      if (state.templateGroups[h].id == groupId) {
        state.templateGroups[h].templates_next_page++;
        break;
      }
    }
  },

  groupTemplatesFetchAllSuccess(state, response) {
    for (let i = 0; i < state.templateGroups.length; i++) {
      if (state.templateGroups[i].id === response.groupId) {
        for (let j = 0; j < response.templates.length; j++) {
          //state.templateGroups[i].total_templates++
          state.templateGroups[i].templates.push(response.templates[j]);
        }
        state.templateGroups[i].template_pages = response.pages;
        break;
      }
    }
    state.loading = false;
  },

  groupCreateSuccess(state, group) {
    state.loading = false;
    group.templates = [];
    group.template_pages = 0;
    group.total_templates = 0;
    group.templates_next_page = 1;

    state.templateGroups.unshift(group);
    state.total++;
  },

  saveTemplateSuccess(state, template) {
    for (let i = 0; i < state.templateGroups.length; i++) {
      if (state.templateGroups[i].id === template.group_id) {
        state.templateGroups[i].templates.push(template);
        state.templateGroups[i].total_templates++;
        break;
      }
    }
    state.loading = false;
  },

  updateMessageSuccess(state, data) {
    for (let h = 0; h < state.templateGroups.length; h++) {
      if (state.templateGroups[h].id == data.groupId) {
        for (let i = 0; i < state.templateGroups[h].templates.length; i++) {
          if (state.templateGroups[h].templates[i].id === data.id) {
            state.templateGroups[h].templates[i].message = data.message;

            state.loading = false;
            return;
          }
        }
      }
    }

    state.loading = false;
  },

  deleteGroupSuccess(state, ids) {
    for (let h = 0; h < ids.length; h++) {
      for (let i = 0; i < state.templateGroups.length; i++) {
        if (state.templateGroups[i].id === ids[h]) {
          state.templateGroups.splice(i, 1);
          state.total--;
          i--;
          break;
        }
      }
    }

    state.loading = false;
  },

  deleteMessageSuccess(state, group) {
    for (let h = 0; h < state.templateGroups.length; h++) {
      if (state.templateGroups[h].id == group.id) {
        for (let i = 0; i < group.messageIds.length; i++) {
          for (let j = 0; j < state.templateGroups[h].templates.length; j++) {
            if (
              state.templateGroups[h].templates[j].id === group.messageIds[i]
            ) {
              state.templateGroups[h].templates.splice(j, 1);
              state.templateGroups[h].total_templates--;
              j--;
              break;
            }
          }
        }
      }
    }

    state.loading = false;
  }
};

export const smsCollection = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
